import React, { useRef, useEffect } from 'react';
import gsap from 'gsap';
import { 
    setEnd
} from '../store/readerSlice'
import { useSelector, useDispatch } from 'react-redux';

const Shake = ({ children }) => {
  const divRef = useRef(null);
  const dispatch = useDispatch()
  const setEndStore = (v) => dispatch(setEnd(v))
  const end = useSelector(state => state.reader.end)

  useEffect(() => {
    if (end) {
      const timeline = gsap.timeline();
      timeline
        .to(divRef.current, { x: 10, duration: 0.1 })
        .to(divRef.current, { x: -10, duration: 0.1 })
        .to(divRef.current, { x: 10, duration: 0.1 })
        .to(divRef.current, { x: -10, duration: 0.1 })
        .to(divRef.current, { x: 0, duration: 0.1 })
        .then(() => setEndStore(false));
    }
        // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [end]);

  return (
    <div ref={divRef}>
      {children}
    </div>
  );
};

export default Shake;
